var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from '@emotion/styled';
import { createComponent } from '@workday/canvas-kit-react/common';
import { Box } from './Box';
import { Flex } from './Flex';
import { getValidChildren } from './utils/getValidChildren';
import { stack } from './utils/stack';
var StackItem = createComponent('div')({
    displayName: 'Stack.Item',
    Component: function (_a, ref, Element) {
        var children = _a.children, elemProps = __rest(_a, ["children"]);
        return (React.createElement(Box, __assign({ as: Element, ref: ref, display: "inline-block", flex: "0 0 auto", minWidth: 0 }, elemProps), children));
    },
});
// prevent `spacing` prop from being passed through to the HTML element
var shouldForwardProp = function (prop) {
    return prop !== 'spacing';
};
var StyledStack = styled(Flex, { shouldForwardProp: shouldForwardProp })(stack);
export var Stack = createComponent('div')({
    displayName: 'Stack',
    Component: function (_a, ref, Element) {
        var children = _a.children, _b = _a.shouldWrapChildren, shouldWrapChildren = _b === void 0 ? false : _b, elemProps = __rest(_a, ["children", "shouldWrapChildren"]);
        var validChildren = getValidChildren(children);
        return (React.createElement(StyledStack, __assign({ as: Element, ref: ref, flexDirection: "row" }, elemProps), shouldWrapChildren
            ? validChildren.map(function (child, index) { return (React.createElement(StackItem, { key: child.props.id || index }, child)); })
            : validChildren));
    },
    subComponents: {
        Item: StackItem,
    },
});
export var HStack = createComponent('div')({
    displayName: 'HStack',
    Component: function (_a, ref, Element) {
        var children = _a.children, _b = _a.flexDirection, flexDirection = _b === void 0 ? 'row' : _b, elemProps = __rest(_a, ["children", "flexDirection"]);
        return (React.createElement(Stack, __assign({ as: Element, ref: ref, flexDirection: flexDirection }, elemProps), children));
    },
    subComponents: {
        Item: StackItem,
    },
});
export var VStack = createComponent('div')({
    displayName: 'VStack',
    Component: function (_a, ref, Element) {
        var children = _a.children, _b = _a.flexDirection, flexDirection = _b === void 0 ? 'column' : _b, elemProps = __rest(_a, ["children", "flexDirection"]);
        return (React.createElement(Stack, __assign({ as: Element, ref: ref, flexDirection: flexDirection }, elemProps), children));
    },
    subComponents: {
        Item: StackItem,
    },
});
